import { render, staticRenderFns } from "./DashboardOld.vue?vue&type=template&id=6d5d420e&scoped=true&"
import script from "./DashboardOld.vue?vue&type=script&lang=js&"
export * from "./DashboardOld.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOld.vue?vue&type=style&index=0&id=6d5d420e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d420e",
  null
  
)

export default component.exports